import React, { ComponentProps } from "react";
import classNames from "classnames";

interface ButtonProps extends ComponentProps<"button"> {
  readonly disabled?: boolean;
  readonly size?: "small" | "large" | "default";
  // prettier-ignore
  readonly color?: 'blue' | 'green' | 'gray' | 'light-gray' | 'red' | 'yellow' | 'charcoal' | 'white' | 'orange' | 'transparent',
  readonly outline?: boolean;
  readonly dashed?: boolean;
  readonly className?: string;
  readonly icon?: boolean;
  readonly rounded?: boolean;
  readonly dataCy?: string;
  readonly dataTestId?: string;
}

const Button = ({
  icon,
  color,
  size = "default",
  outline,
  dashed,
  rounded,
  className,
  dataCy,
  dataTestId,
  ...props
}: ButtonProps) => (
  <button
    className={classNames(
      {
        "bractlet-button": true,
        [`bractlet-button--${color}`]:
          color &&
          [
            "blue",
            "green",
            "gray",
            "light-gray",
            "red",
            "yellow",
            "charcoal",
            "white",
            "orange",
            "transparent",
          ].includes(color),
        [`bractlet-button--${size}`]: ["small", "large"].includes(size),
        "bractlet-button--icon": icon,
        "bractlet-button--outline": outline,
        "bractlet-button--rounded": rounded,
        "bractlet-button--dashed": dashed,
      },
      className
    )}
    type="button"
    data-cy={dataCy ?? "bractlet-button"}
    data-testid={dataTestId}
    {...props}
  />
);

export default Button;
